/**
 * Putting a sprite on a canvas, which every page here needs to do.
 *
 * The workbench blits eight times and the welcome page twelve, and both had
 * their own copy of it. They had not drifted yet, but the failure mode if they
 * did is the quiet kind: one page turns sprites to soup at some zoom levels and
 * the other does not, and nothing says why.
 *
 * Deliberately knows nothing about the pixel grid. That is an editing aid, it
 * belongs to the one canvas somebody is editing, and pushing it in here is what
 * would make this a settings-aware function rather than a drawing one.
 */
export function blit(
	target: HTMLCanvasElement,
	source: { width: number; height: number; data: Uint8Array },
	scale: number,
	/** How many copies across and down, for judging whether a tile seams. */
	times = 1,
) {
	const w = source.width * scale;
	const h = source.height * scale;
	target.width = w * times;
	target.height = h * times;
	const ctx = target.getContext("2d");
	if (!ctx) return;
	const off = new OffscreenCanvas(source.width, source.height);
	const octx = off.getContext("2d");
	if (!octx) return;
	octx.putImageData(new ImageData(new Uint8ClampedArray(source.data), source.width, source.height), 0, 0);
	// Nearest neighbour, or every sprite turns to soup the moment it is enlarged.
	ctx.imageSmoothingEnabled = false;
	ctx.clearRect(0, 0, target.width, target.height);
	for (let ty = 0; ty < times; ty++) {
		for (let tx = 0; tx < times; tx++) ctx.drawImage(off, tx * w, ty * h, w, h);
	}
}
